import { filterClasses } from "@swivl-mono/helpers";

import { ChannelColors, GetChannelFromParam } from "../../../Helpers/Conversations/Conversations.Helper";

const CHANNEL_TABS = [
  { key: "web", label: "Web" },
  { key: "sms", label: "SMS" },
  { key: "voice", label: "Voice" }
] as const;

// Adjacent w-16 slots, no gap — the bar moves exactly one tab width.
const TAB_BAR_OFFSETS = ["translate-x-0", "translate-x-16", "translate-x-32"];

interface ChannelTabBarProps {
  activeChannel: string;
  onSelect: (channel: string) => void;
  isSelectable: (channel: string) => boolean;
  disabledTitle?: (channel: string) => string | undefined;
}

// Web/SMS/Voice tabs + sliding indicator — shared by console and transcript.
export function ChannelTabBar({ activeChannel, onSelect, isSelectable, disabledTitle }: ChannelTabBarProps) {
  return (
    <div className="relative flex h-full grow items-center text-sm font-semibold">
      {CHANNEL_TABS.map((tab) => {
        const selectable = isSelectable(tab.key);
        return (
          <button
            key={tab.key}
            className={filterClasses(
              "h-full w-16 cursor-pointer transition-colors duration-100",
              "disabled:cursor-not-allowed disabled:text-grey-600",
              ChannelColors[GetChannelFromParam(tab.key)].hover
            )}
            onClick={() => selectable && onSelect(tab.key)}
            disabled={!selectable}
            title={selectable ? undefined : disabledTitle?.(tab.key)}
            type="button"
          >
            {tab.label}
          </button>
        );
      })}

      <div
        className={filterClasses(
          "absolute bottom-0 left-0 h-[3px] w-16 transition-transform duration-300 ease-in-out",
          ChannelColors[GetChannelFromParam(activeChannel)].bg,
          TAB_BAR_OFFSETS[CHANNEL_TABS.findIndex((t) => t.key === activeChannel)] ?? "translate-x-0"
        )}
      />
    </div>
  );
}
